/* WJW Increment 26 — one Shopify-backed predictive source, two presentations.
 * - Mobile global input: inline suggestions below the field, never a second drawer.
 * - Product-only full grid: separate compact informational Pages/Articles results.
 * Shopify's existing predictive-search Liquid renders products & prices; no new math.
 */
(() => {
  'use strict';
  const minLength = 2;
  const source = (window.theme && window.theme.routes && window.theme.routes.predictive_search_url) || '/search/suggest';
  const resultSelector = '#shopify-section-predictive-search';
  function searchUrl(query) {
    const params = new URLSearchParams({q: query, 'resources[type]': 'product,article,page,query',
      'resources[limit]': '10', 'resources[options][fields]': 'title,product_type,vendor,variants.title,variants.sku',
      section_id:'predictive-search'});
    return `${source}?${params.toString()}`;
  }
  async function search(query, signal) {
    const response = await fetch(searchUrl(query), { signal, credentials:'same-origin' });
    if (!response.ok) throw new Error('Predictive search unavailable');
    const html = await response.text();
    const page = new DOMParser().parseFromString(html,'text/html');
    return page.querySelector(resultSelector);
  }
  function safeLinks(container, selector, max) {
    if (!container) return [];
    return [...container.querySelectorAll(selector)].slice(0,max).map(el => {
      const a = el.matches('a') ? el : el.querySelector('a[href]');
      if (!a) return null;
      const href = a.getAttribute('href') || '';
      if (!(href.startsWith('/') && !href.startsWith('//'))) return null;
      const link = document.createElement('a');
      link.href = href;
      link.textContent = a.textContent.trim();
      link.className = 'wjw-search-info__item';
      return link;
    }).filter(Boolean);
  }
  function infoGroup(title, links) {
    if (!links.length) return null;
    const block = document.createElement('div');
    block.className='wjw-search-info__group';
    const heading = document.createElement('h3');
    heading.textContent=title;
    block.appendChild(heading);
    links.forEach(link=>block.appendChild(link));
    return block;
  }
  function groups(root, limit) {
    return [infoGroup('Pages',safeLinks(root,'.wjw-predictive-page',limit)),
      infoGroup('Articles',safeLinks(root,'.wjw-predictive-article',limit))].filter(Boolean);
  }
  function setupInline(form) {
    const input=form.querySelector('.mobile-search-input');
    const dropdown=form.querySelector('[data-wjw-inline-results]');
    const list=form.querySelector('[data-wjw-inline-list]');
    if (!input || !dropdown || !list) return;
    let request=null, sequence=0, debounceTimer=null;
    const visible=(on)=>{dropdown.hidden=!on;input.setAttribute('aria-expanded',String(on));};
    function close(){ sequence++;clearTimeout(debounceTimer);request?.abort();visible(false); }
    async function query() {
      const value=input.value.trim();
      const token=++sequence;
      request?.abort();
      if(value.length<minLength){visible(false);list.replaceChildren();return;}
      const controller=new AbortController();request=controller;
      list.textContent='Searching…';visible(true);
      try {
        const result=await search(value,controller.signal);
        if(token!==sequence) return;
        const parts=[];
        const productItems=result ? [...result.querySelectorAll('.product-cart-item')].slice(0,4) : [];
        if(productItems.length) {
          const wrapper=document.createElement('div');
          wrapper.className='wjw-inline-suggestions__products';
          const title=document.createElement('h3');title.textContent='Products';wrapper.appendChild(title);
          // These are Shopify-rendered product-card-small snippets, with original
          // prices and image URLs. No client-side price conversion is performed.
          productItems.forEach(card=>wrapper.appendChild(document.importNode(card,true)));
          parts.push(wrapper);
        }
        parts.push(...groups(result,3));
        const sugg=safeLinks(result,'.thb-predictive-search--popular a',3);
        if(sugg.length)parts.push(infoGroup('Suggestions',sugg));
        if(!parts.length){
          const empty=document.createElement('p');
          empty.className='wjw-inline-suggestions__empty';
          empty.textContent='No suggestions. Try viewing all results.';
          parts.push(empty);
        }
        list.replaceChildren(...parts);
        visible(true);
      } catch(e) {
        if(e.name==='AbortError' || token!==sequence)return;
        const msg=document.createElement('p');msg.className='wjw-inline-suggestions__empty';
        msg.textContent='Suggestions unavailable. Use View all results.';
        list.replaceChildren(msg);visible(true);
      }
    }
    input.addEventListener('input',()=>{clearTimeout(debounceTimer);debounceTimer=setTimeout(query,240);});
    input.addEventListener('focus',()=>{if(input.value.trim().length>=minLength)query();});
    input.addEventListener('keydown',e=>{if(e.key==='Escape'){close();input.blur();}});
    document.addEventListener('pointerdown',e=>{if(!form.contains(e.target))close();});
    form.addEventListener('submit',e=>{if(!input.value.trim()){e.preventDefault();return;}close();});
  }
  function setupExtras(section){
    const query=section.getAttribute('data-search-query')?.trim();
    const target=section.querySelector('[data-wjw-search-extras-groups]');
    if(!query || query.length<minLength || !target)return;
    const controller=new AbortController();
    search(query,controller.signal).then(root=>{
      if(!section.isConnected)return;
      const parts=groups(root,5);
      if(!parts.length)return;
      target.replaceChildren(...parts);section.hidden=false;
    }).catch(()=>{/* Core products, filters and paging remain functional. */});
  }
  function init(){
    document.querySelectorAll('.mobile-global-search .mobile-search-form').forEach(setupInline);
    document.querySelectorAll('[data-wjw-search-extras]').forEach(setupExtras);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
